import type {ReactNode} from 'react'
import {Checkbox} from '@freckle/educator-materials/ts/components/checkbox'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {H3} from '@freckle/educator-materials/ts/components/typography'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {
  header,
  checkboxWrapper,
  imageWrapper
} from '@freckle/school/ts/rostering/components/common/clean-up-row/clean-up-row.module.scss'
import {LearnMore} from '@freckle/school/ts/rostering/components/common/clean-up-row/learn-more'

type Props = {
  src: string
  title: string
  subTitle?: string
  description: string
  children: ReactNode
  isChecked: boolean
  onChange?: () => void
  checkboxId: string
  checkboxDataTest?: string
}

export default function CleanUpRow(props: Props) {
  const {
    src,
    title,
    description,
    children,
    isChecked,
    onChange,
    checkboxId,
    checkboxDataTest,
    subTitle
  } = props

  const subTitleNode = subTitle !== undefined ? <Text style="subtitle-2">{subTitle}</Text> : null

  return (
    <Container>
      <div className={header}>
        <div className={checkboxWrapper}>
          <Checkbox
            disabled={onChange === undefined}
            id={checkboxId}
            label=""
            onChange={onChange ?? (() => {})}
            checked={isChecked}
            dataTest={checkboxDataTest}
          />
        </div>
        <Image className={imageWrapper} src={src} />
        <div>
          <H3>{title}</H3>
          <div>{subTitleNode}</div>
          <p>{description}</p>
          <div>
            <LearnMore>{children}</LearnMore>
          </div>
        </div>
      </div>
    </Container>
  )
}
